import React, {useState} from 'react';

import Select from '../../../CoreWrappers/Select';
import styled from 'styled-components';

const SELECT_NORMAL = 'selectNormal';

const SelectDrydock = () => {
	const [values, setValues] = useState({
		[SELECT_NORMAL]: null
	});

	const handleChange = (id, newValue) => setValues({...values, [id]: newValue});

	const options = [
		{id: 1, label: 'Option 1'},
		{id: 2, label: 'Option 2'},
		{id: 3, label: 'Option 3'},
		{id: 4, label: 'Option 4'},
		{id: 5, label: 'Option 5'},
		{id: 6, label: 'Option 6'},
		{
			id: 7,
			label:
				'Option 7Option 7Option 7Option 7Option 7Option 7Option 7Option 7Option 7Option 7Option 7Option 7Option 7Option 7'
		},
		{id: 8, label: 'Option 8'}
	];

	const renderSelectNormal = () => {
		const id = SELECT_NORMAL;
		const props = {
			id,
			value: values[id],
			onChange: (newValue) => handleChange(id, newValue),
			label: 'Normal select',
			options
		};
		return (
			<StyledMaxWrapper>
				<Select {...props} />
			</StyledMaxWrapper>
		);
	};

	const renderSelectFilter = () => {
		const id = SELECT_NORMAL;
		const props = {
			id,
			value: values[id],
			onChange: (newValue) => handleChange(id, newValue),
			label: 'Filter select',
			options,
			filter: true
		};
		return (
			<StyledMaxWrapper>
				<Select {...props} />
			</StyledMaxWrapper>
		);
	};

	const renderSelectGroup = () => {
		const id = SELECT_NORMAL;
		const props = {
			id,
			value: values[id],
			onChange: (newValue) => handleChange(id, newValue),
			label: 'Group select',
			options: [
				{
					id: 'g1',
					label: 'Group 1',
					options: [
						{id: 1, label: 'Option 1'},
						{id: 2, label: 'Option 2'},
						{id: 3, label: 'Option 3'},
						{id: 4, label: 'Option 4'}
					]
				},
				{
					id: 'g2',
					label:
						'Group 2Group 2Group 2Group 2Group 2Group 2Group 2Group 2Group 2Group 2Group 2Group 2Group 2Group 2Group 2Group 2',
					options: [
						{id: 5, label: 'Option 5'},
						{id: 6, label: 'Option 6'},
						{
							id: 7,
							label:
								'Option 7Option 7Option 7Option 7Option 7Option 7Option 7Option 7Option 7Option 7Option 7Option 7Option 7Option 7'
						},
						{id: 8, label: 'Option 8'}
					]
				}
			],
			filter: true
		};
		return (
			<StyledMaxWrapper>
				<Select {...props} />
			</StyledMaxWrapper>
		);
	};

	const renderSelectError = () => {
		const id = SELECT_NORMAL;
		const props = {
			id,
			value: values[id],
			onChange: (newValue) => handleChange(id, newValue),
			label: 'Normal select',
			options,
			errorMessage: 'This is an error'
		};
		return (
			<StyledMaxWrapper>
				<Select {...props} />
			</StyledMaxWrapper>
		);
	};

	return (
		<>
			{renderSelectNormal()}
			{renderSelectFilter()}
			{renderSelectGroup()}
			{renderSelectError()}
		</>
	);
};

export default SelectDrydock;

const StyledMaxWrapper = styled.div`
	max-width: 25vw;
`;
